<template>
  <div>
    <Menu />

    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Crianças e mulheres"
            description="Beneficiários do Bolsa Família"
            url="/bolsa-familia"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-9551"
            pageIdentifier="bolsa-familia-criancas-mulheres"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw
                  ?.bolsa_familia_criancas_mulheres_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw
                ?.bolsa_familia_criancas_mulheres_ajuda || 0
            "
            keyAjudaModalInformacao="bolsa_familia_criancas_mulheres_ajuda"
          />
        </div>

        <div class="col-md-12">
          <SelectsV2
            v-if="enableSelect == 1"
            :callbackOnChangeEquipe="onChangeEquipe"
            :activeOptionSemEquipe="false"
            :activeSelectProfissionais="false"
            :activeSelectMicroArea="true"
            :callbackOnChangeMicroArea="onChangeMicroArea"
          />
          <SelectsV2
            v-if="enableSelect == 2"
            :activeSelectEquipes="false"
            :activeSelectProfissionais="false"
            :activeSelectMicroArea="true"
            :callbackOnChangeMicroArea="onChangeMicroArea"
          />
        </div>

        <div class="col-md-12">
          <div class="info-table py-4">
            <div class="info-table-item">
              <Subtitle
                ref="subtitle"
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                @exibirVerificados="handleExibirVerificados"
                :setRed="setRed"
              />
            </div>
            <div class="info-table-item">
              <DownloadFiles
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="bolsa-familia-criancas-mulheres"
                :xls-enabled="false"
                :disabled="loading || !equipe || displayedCadastros.length === 0"
                pdf-label="PDF"
              />
            </div>
          </div>

          <TabelaCadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            :usar-dados-ms="exibirCadastrosVerificados"
            @filterSearch="filterSearch"
          />
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import Subtitle from './Subtitle.vue'
import utils from '@/mixins/utils.js'
import * as Functions from './functions.js'

export default {
  name: 'CriancasMulheres',
  components: {
    Menu,
    Footer,
    SectionTitle,
    SelectsV2,
    DownloadFiles,
    TabelaCadastros,
    Subtitle,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      equipe: '',
      micro_area: '',
      cadastros: [],
      cadastrosEquipe: [],
      cadastrosOriginais: [],
      loading: false,
      filterSearchTable: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      exibirCadastrosVerificados: false,
      setRed: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     *
     * @param {Object} item
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Define a base de cadastros (equipe ou microárea) e reaplica Verificado.
     *
     * @param {Array} lista
     */
    aplicarBaseCadastros(lista) {
      const dados = Array.isArray(lista) ? lista : []
      this.cadastrosOriginais = dados
      this.cadastros = dados
      this.aplicarFiltroVerificadoPadrao()
    },

    /**
     * Aplica os filtros parcialmente/totalmente/verificado.
     *
     * @param {Boolean} vermelho
     * @param {Boolean} verde
     * @param {Boolean} verificado
     */
    filtros(vermelho, verde, verificado = false) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }

      this.filterSearchTable = false
      let data = this.cadastrosOriginais

      this.exibirCadastrosVermelhos = false
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVerificados = false

      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVermelhos = true
      }

      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVerdes = true
      }

      if (verificado === true) {
        data = Functions.exibirVerificados(data)
        this.exibirCadastrosVerificados = true
      }

      this.cadastros = data
    },

    /**
     * Exibe cadastros parcialmente preenchidos (vermelhos).
     *
     * @param {Boolean} event
     */
    handleExibirVermelhos(event) {
      if (event === true) {
        this.filtros(true, false, false)
        return
      }

      this.filtros(false, false, false)
    },

    /**
     * Exibe cadastros totalmente preenchidos (laranja).
     *
     * @param {Boolean} event
     */
    handleExibirVerdes(event) {
      if (event === true) {
        this.filtros(false, true, false)
        return
      }

      this.filtros(false, false, false)
    },

    /**
     * Exibe cadastros verificados (verdes).
     *
     * @param {Boolean} event
     */
    handleExibirVerificados(event) {
      if (event === true) {
        this.filtros(false, false, true)
        return
      }

      this.filtros(false, false, false)
    },

    /**
     * Aplica o filtro Verificado como padrão.
     */
    aplicarFiltroVerificadoPadrao() {
      this.$nextTick(() => {
        if (this.$refs.subtitle) {
          this.$refs.subtitle.marcarVerificado()
        }
        this.filtros(false, false, true)
      })
    },

    /**
     * Limpa filtros de cor e busca da tabela.
     */
    limparFiltrosTabela() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }

      if (this.$refs.subtitle) {
        this.$refs.subtitle.limparFiltros()
      }

      this.filterSearchTable = false
      this.exibirCadastrosVermelhos = false
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVerificados = false
    },

    /**
     * Carrega os cadastros ao trocar a equipe.
     *
     * @param {Object} event
     */
    async onChangeEquipe(event) {
      this.limparFiltrosTabela()
      this.micro_area = ''

      if (event == null) {
        this.equipe = ''
        this.cadastros = []
        this.cadastrosEquipe = []
        this.cadastrosOriginais = []
        return
      }

      this.equipe = event
      this.cadastros = []
      this.cadastrosEquipe = []
      this.cadastrosOriginais = []

      try {
        this.loading = true
        const response = await Functions.getCadastrosPorEquipe(
          this.$store.state.cod_ibge,
          this.equipe.ine_esf_eap
        )
        if (response) {
          this.cadastrosEquipe = response
          this.aplicarBaseCadastros(response)
        }
      } catch (error) {
        console.log(error)
        this.cadastros = []
        this.cadastrosEquipe = []
        this.cadastrosOriginais = []
      } finally {
        this.loading = false
      }
    },

    /**
     * Filtra os cadastros pela microárea selecionada.
     *
     * @param {Object|null} event
     */
    onChangeMicroArea(event) {
      this.limparFiltrosTabela()

      if (event == null) {
        this.micro_area = ''
        this.aplicarBaseCadastros(this.cadastrosEquipe)
        return
      }

      this.micro_area = event.micro_area
      const filtrados = Functions.filtrarPorMicroArea(
        this.cadastrosEquipe,
        this.micro_area
      )
      this.aplicarBaseCadastros(filtrados)
    },

    /**
     * Gera o PDF do mapa de acompanhamento.
     */
    generatePdf() {
      Functions.generatePdf(this.displayedCadastros, this.equipe, {
        usarDadosMs: this.exibirCadastrosVerificados,
      })
    },

    /**
     * Inicializa a tela conforme o perfil do usuário.
     */
    async init() {
      try {
        if (this.enableSelect == 2) {
          const nuIneProfissional =
            this.$store.state.id_funcao == 8 ||
            this.$store.state.id_funcao == 14 ||
            this.$store.state.id_funcao == 15
              ? this.$store.state.nu_ine_vinculada
              : this.$store.state.nu_ine

          const equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == nuIneProfissional
          })

          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
              nu_cnes: equipe.nu_cnes,
              nu_ine: equipe.ine_esf_eap,
            }
            await this.onChangeEquipe(this.equipe)
          }
        }

        if (this.enableSelect == 3) {
          const equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })

          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
              nu_cnes: equipe.nu_cnes,
              nu_ine: equipe.ine_esf_eap,
            }
            await this.onChangeEquipe(this.equipe)

            if (this.$store.state.micro_area) {
              this.onChangeMicroArea({
                micro_area: this.$store.state.micro_area,
              })
            }
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style lang="scss"></style>
